<script lang="ts">
import { defineComponent, onBeforeUnmount, reactive, watch, toRefs } from 'vue'
import { useCurrentUserStore } from '../libs/currentUserStore'
import { useNotificationStore } from '../libs/notificationStore'
import { useRoomStore } from '../libs/roomStore'
import Notifications from './Notifications.vue'
import settings from '../libs/settings'

export default defineComponent({
  components: { Notifications },
  setup () {
    const roomStore = useRoomStore()
    const currentUserStore = useCurrentUserStore()
    const notificationStore = useNotificationStore()
    const audio = reactive<{
      illust: HTMLAudioElement | null,
      message: HTMLAudioElement | null,
      user: HTMLAudioElement | null
    }>({ illust: null, message: null, user: null })
    const playSound = (name: 'illust' | 'message' | 'user') => {
      if (settings.mute) return
      audio[name]?.play().catch(() => null)
    }
    const stopMessagesWatcher = watch(() => roomStore.value?.messages[0]?.id, (_, prevId) => {
      if (prevId === undefined) return
      const length = roomStore.value?.messages.findIndex(v => v.id <= prevId)
      roomStore.value?.messages.slice(0, length).forEach(message => {
        if (currentUserStore.value?.id === message.user.id) return
        playSound('message')
        notificationStore.push(`${message.user.name}: ${message.text}`)
      })
    })
    const stopIllustsWatcher = watch(() => roomStore.value?.illusts[0]?.id, (_, prevId) => {
      if (prevId === undefined) return
      const length = roomStore.value?.illusts.findIndex(v => v.id <= prevId)
      roomStore.value?.illusts.slice(0, length).forEach(illust => {
        if (currentUserStore.value?.id === illust.user_id) return
        playSound('illust')
        notificationStore.push(`${illust.user?.name}さんがイラストを投稿しました！`)
      })
    })
    const stopUsersWatcher = watch(() => roomStore.value?.users, (current, prev) => {
      if (current === undefined || prev === undefined) return
      const ids = new Set(prev.map(v => v.id))
      const newUsers = current.filter(v => !ids.has(v.id))
      newUsers.forEach(user => {
        if (currentUserStore.value?.id === user.id) return
        const message = `${user.name}さんが入室しました`
        if (notificationStore.list[notificationStore.list.length - 1]?.message === message) return
        playSound('user')
        notificationStore.push(message)
      })
    })
    onBeforeUnmount(() => {
      stopMessagesWatcher()
      stopIllustsWatcher()
      stopUsersWatcher()
    })
    return {
      ...toRefs(audio),
      settings
    }
  }
})
</script>

<template>
  <audio ref="illust" preload="auto"><source src="../assets/img.wav" type="audio/wav"></audio>
  <audio ref="message" preload="auto"><source src="../assets/chat.wav" type="audio/wav"></audio>
  <audio ref="user" preload="auto"><source src="../assets/click.wav" type="audio/wav"></audio>
  <Notifications v-if="settings.popup" />
</template>
